import { useEffect, useRef } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { Tabs } from 'expo-router';
import { useIsFocused } from '@react-navigation/native';

export default function TabLayout() {
  // The root stack starts on (tabs), so the map stays mounted under every
  // deep-linked page (/event, /post, /start, /update). The stack marks the
  // covered screen aria-hidden but leaves its controls in the tab order, so
  // keyboard users tabbed into the map's invisible search box. `inert` takes
  // the whole covered screen out of focus and the accessibility tree until
  // the page on top pops. Web only: native stacks don't share focus this way.
  const focused = useIsFocused();
  const containerRef = useRef<View>(null);
  useEffect(() => {
    if (Platform.OS !== 'web') return;
    const node = containerRef.current as unknown as HTMLElement | null;
    if (!node) return;
    if (focused) node.removeAttribute('inert');
    else node.setAttribute('inert', '');
  }, [focused]);

  return (
    <View ref={containerRef} style={styles.container}>
      <Tabs
        tabBar={() => null}
        screenOptions={{
          headerShown: false,
        }}>
        <Tabs.Screen name="index" options={{ title: 'Community' }} />
        <Tabs.Screen name="feed" options={{ title: 'News' }} />
        <Tabs.Screen name="funding" options={{ title: 'Funding' }} />
        <Tabs.Screen name="create" options={{ title: 'Create' }} />
        <Tabs.Screen name="alerts" options={{ title: 'Alerts' }} />
        <Tabs.Screen name="search" options={{ title: 'Search' }} />
      </Tabs>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
